<template>
  <div
    id="app"
    :style="{
      background: `#01090b url(${getImageUrlWithCDN_LOCAL('/light_public/home_view_bg.png')}) no-repeat center top / 100%`,
    }"
  >
    <van-config-provider>
      <nav-bar />
      <router-view v-slot="{ Component }">
        <section class="app-wrapper">
          <keep-alive :include="keepAliveRouteNames">
            <component :is="Component" />
          </keep-alive>
        </section>
      </router-view>
    </van-config-provider>

    <div v-if="hadToken" class="customer-service-icon-box" @click="handleService()">
      <img
        class="customer-service-icon"
        :src="getImageUrlWithCDN_LOCAL('/light_public/customer_service_icon.png')"
      />
    </div>
  </div>
</template>

<script setup>
import { STORAGE_LANG_KEY, STORAGE_TOKEN_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { useRouteCacheStore } from '@/stores'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
const router = useRouter()
const route = useRoute()
const { t } = useI18n()
// 国际化
import { locale } from '@/utils/i18n'
const getLocale = () => {
  locale.value = localStorage.getItem(STORAGE_LANG_KEY) || 'pt-BR'
}
getLocale()

onMounted(() => {
  document.querySelector('.loadingbg').style.display = 'none'
  // 动态加载主题样式
  // setDefaultTheme()
  // const iconUrl = '/favicon.ico'
  const iconUrl = '/icon.png'
  const iconUrlApple = '/pwa-192x192.png'
  useHead({
    title: () => t('app.name'),
    meta: [
      {
        name: 'description',
        content: () => t('app.description'),
      },
    ],
    link: [
      {
        rel: 'icon',
        type: 'image/x-icon',
        href: iconUrl, // 动态设置
      },
      {
        rel: 'apple-touch-icon',
        href: iconUrlApple, // 动态设置 Apple Touch Icon
      },
    ],
  })
})

const routeCacheStore = useRouteCacheStore()
const keepAliveRouteNames = computed(() => {
  return routeCacheStore.routeCaches
})

import { useUserStore } from '@/stores'
const userStore = useUserStore()

const hadToken = computed(() => {
  return !!userStore.userInfo.token
})

const handleService = () => {
  const operationData = JSON.parse(localStorage.getItem('operationData')) || {}
  if (operationData.service_url && operationData.service_url !== undefined) {
    window.open(operationData.service_url, '_blank')
  }
}
</script>

<style scoped lang="scss">
.app-wrapper {
  width: 100%;
  position: relative;
  background-color: var(--bg-color-1);
  overflow: hidden;
}

.initial-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: var(--bg-color-8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  color: #333;
  font-size: 14px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.customer-service-icon-box {
  position: fixed;
  bottom: 64px;
  right: 0;

  .customer-service-icon {
    width: 88px;
    height: 88px;
  }
}
</style>
